import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SwFooterComponent } from './sw-footer/sw-footer.component';
import { SwHeaderComponent } from './sw-header/sw-header.component';
import { SwHomeComponent } from './sw-home/sw-home.component';
import { SwMainComponent } from './sw-main/sw-main.component';
import { SwMenuComponent } from './sw-menu/sw-menu.component';
import { SwPersonViewComponent } from './sw-person-view/sw-person-view.component';
import { FormsModule } from '@angular/forms';
import { SwLockSystemComponent } from './sw-lock-system/sw-lock-system.component';
import { HttpClientModule } from '@angular/common/http';
import { SwJwtService } from '../librarys/serves/sw-jwt.service';
import { SwException404Component } from './sw-exception/404.component';
import { SwException403Component } from './sw-exception/403.component';
import { SwSwitchUserComponent } from './sw-switch-user/sw-switch-user.component';
import { SwChangePasswordComponent } from './sw-change-password/sw-change-password.component';
import { DictionaryService } from '../librarys/serves/public/dictionary.service';
import { OninitService } from '../librarys/serves/oninit.service';
import { SwMenuService } from '../librarys/serves/sw-menu.service';
import { ProcessToDosService } from '../librarys/serves/public/process-to-dos.service';
import { BasicComponentsModule } from '../librarys/components/basic-components/basic-components.module';
import { SwLoadingmaskComponent } from '../librarys/components/basic-components/sw-loadingmask/sw-loadingmask.component';
import { AppComponentsModule } from '../librarys/components/app-components/app-components.module';
import { SwTreeMenuComponent } from './sw-tree-menu/sw-tree-menu.component';
import { SystemIdService } from '../librarys/serves/public/system-id.service';
import { SwNotificationComponent } from './sw-notification/sw-notification.component';
import { SwHeaderNoticeComponent } from './sw-header/sw-header-notice/sw-header-notice.component';
import { SwCompatibilityComponent } from './sw-exception/compatibility.component';
import { SelectProductComponent } from './select-product/select-product.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    BasicComponentsModule,
    AppComponentsModule,
    FormsModule
  ],
  exports:[
    SwFooterComponent,
    SwHeaderComponent,
    SwTreeMenuComponent,
    SwMainComponent,
    SwHomeComponent,
    SwMenuComponent,
    SwLoadingmaskComponent,
    SwException404Component
  ],
  providers:[SwJwtService,DictionaryService,SwMenuService,OninitService,ProcessToDosService],
  entryComponents: [SwLoadingmaskComponent,SwPersonViewComponent,SwLockSystemComponent,SwSwitchUserComponent,SwChangePasswordComponent,SwHeaderNoticeComponent,SelectProductComponent],
  declarations: [
    SwLoadingmaskComponent,
    SwFooterComponent,
    SwHeaderComponent,
    SwHomeComponent,
    SwMainComponent,
    SwMenuComponent,
    SwTreeMenuComponent,
    SwPersonViewComponent,
    SwLockSystemComponent,
    SwException404Component,
    SwException403Component,
    SwCompatibilityComponent,
    SwSwitchUserComponent,
    SwChangePasswordComponent,
    SwNotificationComponent,
    SwHeaderNoticeComponent,
    SelectProductComponent]
})
export class HomeModule { }

